import React from 'react';

import { UseUserInfo } from '../../../../../../helpers/hooks/useUserInfo';
import type { CatchConditions as CatchConditionsData } from '../../../../types/CatchConditions';
import type { User } from '../../../../types/User';

import { BasicCatchInfoCards } from './BasicCatchInfoCards';
import { PremiumCatchInfoCards } from './PremiumCatchInfoCards';

interface CatchConditionsProps {
  catchConditions: CatchConditionsData | null | undefined;
  currentUser: UseUserInfo;
  postUser: User | undefined;
}

export const CatchConditions = ({
  catchConditions,
  currentUser,
  postUser,
}: CatchConditionsProps) => {
  const { user: currentUserData, isPremium: isCurrentUserPremium } = currentUser;
  const ownedByCurrentUser = postUser?._id === currentUserData?._id;
  const showCTAButton = !isCurrentUserPremium;

  return catchConditions && (isCurrentUserPremium || ownedByCurrentUser) ? (
    <PremiumCatchInfoCards catchConditions={catchConditions} currentUser={currentUser} />
  ) : (
    <BasicCatchInfoCards showCTAButton={showCTAButton} />
  );
};
